import ApiConnector from "@/repository/connector";
import Generations from "./Generations";

class Models {
  Generations = Generations;

  async get({ makeId, params }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/makes/${makeId}/models/`,
      { params },
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Models();
